import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n      ", "\n    "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n      margin: 0 !important;\n    "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n        padding: 0px 6px;\n        margin-bottom: -8px;\n      "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n        padding: 0px 6px;\n        margin-bottom: -8px;\n      "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n        padding: 0px 4px;\n        margin-bottom: -6px;\n      "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-radius: 2px;\n    padding: 0px 4px;\n    width: auto;\n    margin-left: 6px;\n    margin-bottom: -6px;\n    ", "\n    ", "\n    ", "\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      margin-bottom: 12px;\n      ", ";\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      margin-bottom: 12px;\n      ", ";\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      margin-bottom: 6px;\n      ", ";\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  font-weight: 600;\n  z-index: 1;\n  user-select: none;\n\n  /* Size */\n  margin-bottom: 8px;\n  ", ";\n  ", "\n  ", "\n  ", "\n\n  /* Colors */\n  color: ", ";\n  ", "\n  ", "\n\n  /* Inset */\n  ", "\n\n  /* No Margin */\n  ", "\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from "react";
import styled, { css } from "styled-components";
import { text, textEllipsis } from "../../Utils/Constants";

var InputLabel = function InputLabel(props) {
  return React.createElement(StyledInputLabel, props, props.children);
};

export default InputLabel;
export var StyledInputLabel = styled.label(_templateObject(), text("text", "s"), function (props) {
  return props.size === "s" && css(_templateObject2(), text("text", "s"));
}, function (props) {
  return props.size === "l" && css(_templateObject3(), text("text", "m"));
}, function (props) {
  return props.size === "xl" && css(_templateObject4(), text("text", "m"));
}, function (props) {
  return props.theme.color("text", "primary");
}, function (props) {
  return props.error && css(_templateObject5(), props.theme.color("action", "danger"));
}, function (props) {
  return props.valid && css(_templateObject6(), props.theme.color("action", "success"));
}, function (props) {
  return props.inset && css(_templateObject7(), function (props) {
    return props.theme.color("background", "primary:lighten");
  }, function (props) {
    return props.size === "s" && css(_templateObject8());
  }, function (props) {
    return props.size === "l" && css(_templateObject9());
  }, function (props) {
    return props.size === "xl" && css(_templateObject10());
  });
}, function (props) {
  return props.noMargin && css(_templateObject11());
}, function (props) {
  return props.ellipsis && css(_templateObject12(), textEllipsis);
});